import React, { useEffect, useState } from 'react';
import {
    MapPin,
    Users,
    Phone,
    Building,
    Clock,
    Receipt,
    Workflow,
    ChevronRightIcon,
    ChevronLeftIcon,
    Trash2
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Loading from '../../components/Loading';

export const UnifiedClientCompany = ({accounts = [],handleDelete,
    page,
    totalPages,
    setPage,loading }) => {

    const navigate = useNavigate();
    const generateStartupInvoice = (clientId) => {
        const client = accounts.find((c) => c.id === clientId);
        if (client) {
            alert(
                `Generating startup onboarding invoice for ${client.accountName}\n\nServices:\n- Company Registration: ₹15,000\n- GST Registration: ₹5,000\n- TAN Registration: ₹2,000\n- Compliance Setup: ₹8,000\n\nTotal: ₹30,000 + GST`
            );
        }
    };



    if (loading) {
        return (
            <div className="flex items-center justify-center h-screen w-full bg-white">
                <Loading size="lg" message="Loading clients..." />
            </div>
        );
    }

    return (
        <div className="flex flex-col h-screen space-y-2">
        {accounts.length >0 ? (

            <div className="flex-1 overflow-y-auto p-2 relative">
                <div className="fixed top-15 right-12 flex items-center space-x-2 z-50">
                    <button
                        onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
                        disabled={page === 0}
                        className="p-2 bg-white/80 rounded-full shadow hover:bg-white"
                    >
                        <ChevronLeftIcon className="h-4 w-4 text-gray-700" />
                    </button>
                    <span className="text-sm text-gray-800 bg-white/70 px-2 py-1 rounded">
                        {page + 1}/{totalPages}
                    </span>
                    <button
                        onClick={() => setPage((prev) => Math.min(prev + 1, totalPages - 1))}
                        disabled={page >= totalPages - 1}
                        className="p-2 bg-white/80 rounded-full shadow hover:bg-white"
                    >
                        <ChevronRightIcon className="h-4 w-4 text-gray-700" />
                    </button>
                </div>


                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-2 ">
                    {accounts?.map((client) => (
                        <div
                            key={client.id}
                            className="rounded-lg shadow-sm border bg-white border-gray-200 px-6 py-2 hover:shadow-md transition-shadow cursor-pointer"
                            onClick={() => {
    navigate(`/accounts/view/${client.id}`);
}}

                        >
                            <div className="flex items-start justify-between mb-1">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {client.accountName}
                                    </h3>
                                    <p className="text-sm text-gray-500">
                                        {client?.businessInformation?.company || 'Company'}
                                    </p>
                                </div>
                                {client.isStartup && (
                                    <span className="px-2 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                        Startup
                                    </span>
                                )}
                            </div>

                            <div className="grid grid-cols-2 gap-2 mb-2">
                                <div className="flex items-center space-x-2">
                                    <MapPin className="h-4 w-4 text-gray-400" />
                                    <span className="text-sm text-gray-600">
                                        {client?.businessInformation?.locations?.length || 0} Locations
                                    </span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Building className="h-4 w-4 text-gray-400" />
                                    <span className="text-sm text-gray-600">
                                        {client?.businessInformation?.gstRegistrations?.length || 0} GST
                                    </span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Workflow className="h-4 w-4 text-gray-400" />
                                    <span className="text-sm text-gray-600">
                                        {client?.workflowCount || 0} Workflows
                                    </span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <Clock className="h-4 w-4 text-gray-400" />
                                    <span className="text-sm text-gray-600">
                                        {client.tasks?.length} Tasks
                                    </span>
                                </div>
                            </div>

                            <div className="space-y-3">
                                <div className="flex justify-between items-center">
                                    <span className="text-sm text-gray-600">Annual Revenue</span>
                                    <span className="font-semibold text-green-600">
                                        ₹{client?.businessInformation?.annualRevenue || 0}
                                    </span>
                                </div>
                              
                            </div>

                            <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-200">
                                <div className="flex items-center space-x-2">
                                    <Users className="h-4 w-4 text-gray-400" />
                                    <span className="text-sm text-gray-600">{client.accountOwner}</span>
                                </div>
                                <div className="flex space-x-2" onClick={(e) => e.stopPropagation()}>
                                    <button
  onClick={() => window.location.href = `tel:${client.fax}`}
  className="text-blue-600 hover:text-blue-800"
>
  <Phone className="h-4 w-4" />
</button>


                                    {client.isStartup && client.onboardingStatus !== 'Complete' && (
                                        <button
                                            onClick={() => generateStartupInvoice(client.id)}
                                            className="text-purple-600 hover:text-purple-800"
                                        >
                                            <Receipt className="h-4 w-4" />
                                        </button>
                                    )}
                                  <button
    onClick={() => handleDelete(client.id)}
    className="text-red-600 hover:text-red-800 transition"
    title="Delete account"
>
    <Trash2 className="h-4 w-4" />
</button>

                                </div>
                            </div>
                        </div>

                    ))}
                </div>

             
            </div>
):<div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 py-2 ">  No data available.</div>}

        </div>

    );
};

